import React, { useState } from 'react';
import logo from './../assets/images/logo.png';
import { Link } from 'react-router-dom'; 
import Navbar from './../pages/Navbar';
import Footer from './../pages/Footer';
import { useNavigate } from 'react-router-dom';

function Signup() {
    const [formData, setFormData] = useState({
        Type: "",
        Name: "",
        Email: "",
        Number: "",
        Address: "",
        Password: "",
        CompanyName:"",
        ConfirmPassword: "",
        adharCard: null,
        panCard: null,
        photo: null,
      });
    
      const navigate = useNavigate(); // React Router hook
      const [errors, setErrors] = useState({});
    
      const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
      };
    
      const handleFileChange = (e) => {
        const { id, files } = e.target;
        setFormData({ ...formData, [id]: files[0] });
      };
    
      const validate = () => {
        const newErrors = {};

        if (!formData.Type || formData.Type === "select")
            newErrors.type = "Please select a valid type.";
        
        if (!formData.Name) newErrors.name = "Name is required.";
        if (!formData.Email) newErrors.email = "Email is required.";
        else if (!/\S+@\S+\.\S+/.test(formData.Email))
          newErrors.email = "Invalid email format.";
    
        if (!formData.Number) newErrors.phone = "Phone number is required.";
        else if (!/^\d{10}$/.test(formData.Number))
          newErrors.phone = "Phone number must be 10 digits.";
    
        if (!formData.Address) newErrors.address = "Address is required.";
    
        if (!formData.Password) newErrors.password = "Password is required.";
        else if (formData.Password.length < 6)
          newErrors.password = "Password must be at least 6 characters.";
    
        if (formData.Password !== formData.ConfirmPassword)
          newErrors.confirmPassword = "Passwords do not match.";
        if (!formData.CompanyName) newErrors.CompanyName = "Company Name is required.";
    
    
        if (!formData.adharCard)
          newErrors.adharCard = "Adhar Card file is required.";
        if (!formData.panCard) newErrors.panCard = "PAN Card file is required.";
        if (!formData.photo) newErrors.photo = "Photo is required.";
    
        return newErrors;
      };
    
    //   const handleSubmit = (e) => {
    //     e.preventDefault();
    //     const newErrors = validate();
    //     if (Object.keys(newErrors).length > 0) {
    //       setErrors(newErrors);
    //     } else {
    //       setErrors({});
    //       console.log("Form submitted:", formData);
    //       // Add logic for form submission
    //     }
    //   };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const newErrors = validate();
        if (Object.keys(newErrors).length > 0) {
          setErrors(newErrors);
        } else {
          setErrors({});
      
          const formDataToSend = new FormData();
          formDataToSend.append('Type', formData.Type); // Use state values
          formDataToSend.append('Name', formData.Name);
          formDataToSend.append('Email', formData.Email);
          formDataToSend.append('Number', formData.Number);
          formDataToSend.append('Address', formData.Address);
          formDataToSend.append('Password', formData.Password);
          formDataToSend.append('CompanyName', formData.CompanyName);
          formDataToSend.append('PdfFileAdhar', formData.adharCard); // Attach file from state
          formDataToSend.append('PdfFilePan', formData.panCard);
          formDataToSend.append('ImageFile', formData.photo);
    
          console.log('Form data being sent:', formDataToSend);
          
        
        // Send data to the server using fetch Add by jinal
        try {  
            //const response = await fetch('http://localhost:5121/api/LoginRegistration/Register', {
            const response = await fetch('https://apiv2.chakran.in/api/LoginRegistration/Register', {
                method: 'POST',
                body: formDataToSend,
                // headers: {
                //     'Content-Type': 'application/json',
                //   },
                // body: JSON.stringify(formDataToSend),
            });

            console.log('Form data being sent:', formDataToSend);

            if (!response.ok) {
                const errorDetails = await response.text();
                console.error('Error details:', errorDetails);
                throw new Error('Registration failed');
            }

            const data = await response.json();
            console.log('Registration successful:', data);
            navigate('/login'); // Redirect to login page
        } catch (error) {
            console.error('Error during registration:', error.message);
        }
        }
      };
    
  return (
    <>
    <Navbar />
    <div className="container d-flex align-items-center justify-content-center" style={{ minHeight: '90vh'}}>
        <div className="d-flex flex-column justify-content-between">
            <div className="row justify-content-center">
                <div className="col-lg-6 col-xl-5 col-md-10 ">
                    <div className="card card-default mb-0">
                        <div className="card-header pb-0">
                            <div className="app-brand w-100 d-flex justify-content-center border-bottom-0">
                                <Link className="w-auto pl-0" to="/signin">
                                    <img src={logo} alt="Mono" />
                                </Link>
                            </div>
                        </div>
                        <div className="card-body px-4 pb-3 pt-0">
                            <h4 className="text-dark text-center mb-2">Sign Up</h4>
                            {/*<h4 className="text-danger text-center"></h4>*/}
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="form-group col-md-12">
                                        <select
                                            className="form-control"
                                            id="type"
                                            name="Type"
                                            value={formData.type}
                                            onChange={handleChange}
                                            >
                                            <option value="select">select</option>
                                            <option value="Retailers">Retailers</option>
                                            <option value="Guests">Guest</option>
                                            </select>
                                            {errors.type && <span className="text-danger field-validation-valid text-dange">{errors.type}</span>}
                                    </div>
                                    <div className="form-group col-md-12 mb-2">
                                        <input
                                            type="text"
                                            placeholder="Name"
                                            name="Name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            className="form-control"
                                        />
                                        {errors.name && (
                                            <small className="text-danger field-validation-valid text-danger">{errors.name}</small>
                                        )}                            
                                    </div>
                                    <div className="form-group col-md-12 mb-2">
                                        <input
                                            type="email"
                                            placeholder="Email"
                                            name="Email"
                                            value={formData.Email}
                                            onChange={handleChange}
                                            className="form-control"
                                        />
                                        {errors.email && (
                                            <span className="text-danger field-validation-valid text-danger">{errors.email}</span>
                                        )}
                                      
                                    </div>
                                    <div className="form-group col-md-12 mb-2">
                                        <input
                                            type="text"
                                            placeholder="Phone No"
                                            name="Number"
                                            value={formData.phone}
                                            onChange={handleChange}
                                            className="form-control"
                                        />
                                        {errors.phone && (
                                            <span className="text-danger field-validation-valid text-danger">{errors.phone}</span>
                                        )}
                                    </div>
                                    <div className="form-group col-md-12 mb-2">
                                        <textarea
                                            placeholder="Address"
                                            name="Address"
                                            value={formData.Address}
                                            onChange={handleChange}
                                            className="form-control"
                                        ></textarea>
                                        {errors.address && (
                                            <span className="text-danger field-validation-valid text-danger">{errors.address}</span>
                                        )}
                                    </div>
                                    <div className="form-group col-md-12 mb-2">
                                        <input
                                            type="password"
                                            placeholder="Password"
                                            name="Password"
                                            value={formData.Password}
                                            onChange={handleChange}
                                            className="form-control"
                                        />
                                        {errors.password && (
                                            <span className="text-danger">{errors.password}</span>
                                        )}
                                    </div>
                                    <div className="form-group col-md-12 mb-2">
                                        <input
                                            type="password"
                                            placeholder="Confirm Password"
                                            name="ConfirmPassword"
                                            value={formData.ConfirmPassword}
                                            onChange={handleChange}
                                            className="form-control"
                                        />
                                        {errors.confirmPassword && (
                                            <span className="text-danger">
                                            {errors.confirmPassword}
                                            </span>)}
                                    </div>
                                    <div className="form-group col-md-12 mb-2">
                                        <input
                                            type="text"
                                            placeholder="Company Name"
                                            name="CompanyName"
                                            value={formData.CompanyName}
                                            onChange={handleChange}
                                            className="form-control"    
                                        />
                                        {errors.name && (
                                            <small className="text-danger field-validation-valid text-danger">{errors.name}</small>
                                        )}                            
                                    </div>
                                    <div className="form-group col-md-12 mb-2">
                                        <div className="input-group mb-2 mr-sm-2">
                                            <div className="input-group-prepend">
                                                <div className="input-group-text">Adhar Card</div>
                                            </div>
                                            <input
                                                type="file"
                                                className="form-control"
                                                id="adharCard"
                                                accept=".pdf,.jpg,.jpeg,.png"
                                                onChange={handleFileChange}
                                                />
                                                {errors.adharCard && (
                                                <small className="text-danger">
                                                    {errors.adharCard}
                                                </small>
                                                )}
                                        </div>                                          
                                    </div>
                                    <div className="form-group col-md-12 mb-2">
                                        <div className="input-group mb-2 mr-sm-2">
                                            <div className="input-group-prepend">
                                                <div className="input-group-text"> PAN Card</div>
                                            </div>
                                            <input
                                                type="file"
                                                className="form-control"
                                                id="panCard"
                                                accept=".pdf,.jpg,.jpeg,.png"
                                                onChange={handleFileChange}
                                                />
                                                {errors.panCard && (
                                                <small className="text-danger">
                                                    {errors.panCard}
                                                </small>
                                                )}
                                        </div>                                          
                                    </div>
                                    <div className="form-group col-md-12 mb-2">
                                        <div className="input-group mb-2 mr-sm-2">
                                            <div className="input-group-prepend">
                                                <div className="input-group-text">Photo</div>
                                            </div>
                                            <input
                                                type="file"
                                                className="form-control"
                                                id="photo"
                                                accept=".pdf,.jpg,.jpeg,.png"
                                                onChange={handleFileChange}
                                                />
                                                {errors.photo && (
                                                <small className="text-danger">{errors.photo}</small>
                                                )}
                                        </div>                                          
                                    </div> 
                                    <div className="col-md-12">
                                        <button type="submit" className="btn btn-primary btn-pill mt-2 mb-2">Sign Up</button>
                                        <p>
                                            Already have an account?
                                            <Link className="text-blue" to="/signin"> Sign in</Link>
                                        </p>
                                    </div>
                                </div>
                                <input name="__RequestVerificationToken" type="hidden" value="" />
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Footer />
    </>
  );
}
export default Signup;
